export default __webpack_public_path__ + "static/media/Fury of Xotli.6a30eb17.jpg";